import { type Mixpanel } from 'mixpanel-browser';

interface IMixpanelTrackingEventHandler {
    mixpanel: Mixpanel | null;
    isListening: boolean;
    listen(): void;
    setMixpanel(mixpanel: Mixpanel): void;
}

export const mixpanelTrackingEvent: IMixpanelTrackingEventHandler = {
    mixpanel: null,
    isListening: false,
    listen() {
        // API failure / error Mixpanel events are no longer sent from WCP.
    },
    setMixpanel(mixpanel: Mixpanel) {
        this.mixpanel = mixpanel;
    },
};
